var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHumidity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.48 20.38C11.4492 20.3799 10.4366 20.1083 9.544 19.5926C8.65144 19.0769 7.91043 18.3352 7.39551 17.4422C6.88058 16.5492 6.6099 15.5363 6.61069 14.5055C6.61148 13.4747 6.88371 12.4622 7.40001 11.57V11.57L11.76 4C11.8341 3.87345 11.9399 3.76849 12.0671 3.69555C12.1943 3.62261 12.3384 3.58424 12.485 3.58424C12.6316 3.58424 12.7757 3.62261 12.9029 3.69555C13.0301 3.76849 13.136 3.87345 13.21 4L17.57 11.55C18.0867 12.443 18.359 13.4563 18.3593 14.488C18.3597 15.5197 18.0881 16.5332 17.572 17.4265C17.0559 18.3198 16.3135 19.0614 15.4195 19.5763C14.5256 20.0913 13.5117 20.3616 12.48 20.36V20.38Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.44 13.57C15.6141 14.2021 15.5764 14.8738 15.3326 15.4824C15.0888 16.091 14.6523 16.603 14.09 16.94",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumidity);
export default __webpack_public_path__ + "static/media/humidity.7767a2d84d56988e79cc610c643d8078.svg";
export { ForwardRef as ReactComponent };